export const environment = {
  production: true,
  APIPath: window.location.origin + '/api',
  syncFileUploadUrl: '',
  CodeUrl: window.location.origin,
  VisualUrl: 'http://20.188.121.148:3000',
  Interval: 30,
};
